import React, { useRef } from "react";
import { FaStar, FaChevronLeft, FaChevronRight, FaQuoteLeft } from "react-icons/fa";
import "./ReviewSection.css";

const reviews = [
  {
    name: "Sarah Johnson",
    location: "London, UK",
    rating: 5,
    comment:
      "Absolutely loved the place! The view was breathtaking and the staff were super friendly.",
    image:
      "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Ali Khan",
    location: "Dubai, UAE",
    rating: 4,
    comment:
      "Great location and excellent cleanliness. Will definitely come back again!",
    image:
      "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Emily Carter",
    location: "New York, USA",
    rating: 5,
    comment:
      "Top-notch service with luxury vibes. Everything was beyond expectations!",
    image:
      "https://randomuser.me/api/portraits/women/65.jpg",
  },
  {
    name: "Ahmed Hassan",
    location: "Cairo, Egypt",
    rating: 4,
    comment:
      "Very cozy and well-designed rooms. The breakfast buffet was delicious.",
    image:
      "https://randomuser.me/api/portraits/men/77.jpg",
  },
  {
    name: "Sophia Lee",
    location: "Singapore",
    rating: 5,
    comment:
      "I was impressed by the hospitality and modern design. Highly recommended!",
    image:
      "https://randomuser.me/api/portraits/women/51.jpg",
  },
];

const ReviewSection = () => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -350 : 350,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="review-section1">
      <div className="review-header1">
        <h2>What Our Guests Say</h2>
        <p>Real reviews from people who loved their stay with us ❤️</p>
      </div>

      <div className="review-slider-container1">
        <button className="scroll-btn1 left1" onClick={() => scroll("left")}>
          <FaChevronLeft />
        </button>

        <div className="review-slider1" ref={scrollRef}>
          {reviews.map((r, i) => (
            <div className="review-card1" key={i}>
              <div className="quote-icon1">
                <FaQuoteLeft />
              </div>
              <p className="comment1">“{r.comment}”</p>

              <div className="reviewer1">
                <img src={r.image} alt={r.name} />
                <div>
                  <h4>{r.name}</h4>
                  <p>{r.location}</p>
                </div>
              </div>

              <div className="stars1">
                {[...Array(r.rating)].map((_, index) => (
                  <FaStar key={index} />
                ))}
              </div>
            </div>
          ))}
        </div>

        <button className="scroll-btn1 right1" onClick={() => scroll("right")}>
          <FaChevronRight />
        </button>
      </div>
    </section>
  );
};

export default ReviewSection;
